module.exports = __webpack_public_path__ + "img/HospNckud6-Service.dbcd23dc.png";